'use client';
import dynamic from 'next/dynamic';

const FluencyChartInner = dynamic(() => import('./FluencyChartInner'), { ssr: false });

export default function FluencyProgressChart() {
  return <FluencyChartInner />;
}